export default [
  {
    path: "/h5/quotes",
    name: "h5-quotes",
    component: () => import('@/pages/v2/h5/quotes'),
  }
]


// WEBPACK FOOTER //
// ./src/router/v2/h5/quotes/index.js